import { call, put, takeLatest } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import { GarageNetworkApi } from '@apis/GarageNetworkApi';
import { Garage } from '@models/BusinessPartner';
import { Pagination } from '@models/Pagination';
import { garagesFetch, stateUpdate, StateUpdatePayload, GaragesFetchPayload } from './action';

function* handleGaragesFetch(action: Action<GaragesFetchPayload>) {
  const state: StateUpdatePayload = { isLoading: true, error: null };
  yield put(stateUpdate(state));

  try {
    const [garages, pagination] = (yield call(GarageNetworkApi.getAll, action.payload)) as [Garage[], Pagination];

    yield put(
      stateUpdate({
        garages,
        pagination,
        searchParams: action.payload,
        isLoading: false,
        error: null,
      })
    );
  } catch (error) {
    console.error('Failed to fetch garages:', error);
    yield put(
      stateUpdate({
        garages: [],
        isLoading: false,
        error: 'Failed to load garages. Please try again later.',
      })
    );
  }
}

export default function* () {
  yield takeLatest(garagesFetch, handleGaragesFetch);
}
